module.exports = __webpack_public_path__ + "img/bannerb.d529e47a.jpg";